import React, { useRef } from 'react'
import PropTypes from 'prop-types'
import useScrollState from '../../hooks/useScrollState'

// Horizontal scroller for the scorecard tables, with an edge shadow on the side
// that still has table left to reach.
const DetailsScroll = ({ children }) => {
  const scrollRef = useRef(null)
  const { isAtStart, isAtEnd, isScrollable } = useScrollState(scrollRef)

  const shadows = [
    isScrollable && !isAtStart ? 'scrolled' : '',
    isScrollable && !isAtEnd ? 'with-gradient' : '',
  ].join(' ')

  return (
    <div className={`lbv2__details-scroll ${shadows}`}>
      <div className="lbv2__scroll-wrapper expanded" ref={ scrollRef }>
        {children}
      </div>
    </div>
  )
}

DetailsScroll.propTypes = {
  children: PropTypes.node,
}

export default DetailsScroll
